import { getStoredOverride, setStoredOverride } from '../seasonal/seasonalEngine';
import { THEMES } from '../seasonal/themes';
import { isSupabaseConfigured, supabase } from './supabase';

export async function loadPublicThemeOverride() {
  if (!isSupabaseConfigured) return getStoredOverride();
  const { data, error } = await supabase.from('site_settings').select('value').eq('key', 'homepage_theme').maybeSingle();
  if (error || !data?.value) return 'automatic';
  return data.value.mode === 'manual' && THEMES[data.value.theme] ? data.value.theme : 'automatic';
}

export async function savePublicThemeOverride(themeId, userId) {
  setStoredOverride(themeId);
  if (!isSupabaseConfigured) return { localOnly: true };
  const value = themeId === 'automatic'
    ? { mode: 'automatic', theme: 'default', timezone: 'America/Vancouver' }
    : { mode: 'manual', theme: themeId, timezone: 'America/Vancouver' };
  const { error } = await supabase.from('site_settings').upsert({ key: 'homepage_theme', value, updated_by: userId ?? null, updated_at: new Date().toISOString() });
  if (error) throw error;
  return { localOnly: false };
}
